import { Injectable } from '@angular/core';
import { defer, from, map, Observable } from 'rxjs';

export interface FetchSuggestionsOptions {
	includedPrimaryTypes: string[];
	includedRegionCodes: string[];
	language?: string;
}

@Injectable()
export class GooglePlacesAutocompleteService {
	private sessionToken?: google.maps.places.AutocompleteSessionToken;

	async ensureLibraryLoaded(): Promise<void> {
		await google.maps.importLibrary('places');
		if (!this.sessionToken) {
			this.startNewSession();
		}
	}

	startNewSession(): void {
		this.sessionToken = new google.maps.places.AutocompleteSessionToken();
	}

	getSuggestions(query: string, options: FetchSuggestionsOptions): Observable<google.maps.places.AutocompleteSuggestion[]> {
		return defer(() =>
			from(
				google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions({
					input: query,
					sessionToken: this.sessionToken,
					includedPrimaryTypes: options.includedPrimaryTypes,
					includedRegionCodes: options.includedRegionCodes,
					language: options.language ?? 'en',
				}),
			).pipe(map((res) => res.suggestions || [])),
		);
	}

	resolvePlace(prediction: google.maps.places.PlacePrediction, fields: string[]): Observable<google.maps.places.Place> {
		return defer(() => {
			const place = prediction.toPlace();
			return from(place.fetchFields({ fields })).pipe(
				map(() => {
					this.startNewSession();
					return place;
				}),
			);
		});
	}
}
